import { create } from 'zustand'

/**
 * The bridge between the Ask-AI dock's build controls and the Workbench.
 *
 * The dock owns the build session (useAutoAgent lives inside it). While a
 * build plan is attached it REGISTERS its own Continue / Build the rest /
 * Pause handlers here, and the Next step card calls those same functions — so
 * "Continue" on the card and "Continue" on the dock's Review card are one
 * action, never two implementations that could drift.
 */
export interface DockBuildActions {
  continueNextPhase: () => void
  completeEverything: () => void
  pause: () => void
}

interface DockBridgeState {
  project: string | null
  agentStatus: string
  canContinue: boolean
  hasQuestion: boolean
  actions: DockBuildActions | null
  publish: (s: { project: string; agentStatus: string; canContinue: boolean; hasQuestion: boolean;
                 actions: DockBuildActions | null }) => void
  clear: (project?: string) => void
}

export const useDockBridgeStore = create<DockBridgeState>((set, get) => ({
  project: null,
  agentStatus: '',
  canContinue: false,
  hasQuestion: false,
  actions: null,
  publish: (s) => {
    const cur = get()
    if (cur.project === s.project && cur.agentStatus === s.agentStatus
      && cur.canContinue === s.canContinue && cur.hasQuestion === s.hasQuestion
      && cur.actions === s.actions) return
    set(s)
  },
  clear: (project) => {
    if (project && get().project !== project) return
    set({ project: null, agentStatus: '', canContinue: false, hasQuestion: false, actions: null })
  },
}))

/** Fill the dock's message box (it never sends on its own) and open it. */
export const DOCK_PREFILL_EVENT = 'twasta:dock-prefill'

export function prefillDock(text: string): void {
  window.dispatchEvent(new CustomEvent(DOCK_PREFILL_EVENT, { detail: { text } }))
}
